/**
 * Convert a string to a URL-friendly slug
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/[\s_-]+/g, '-') // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
}

/**
 * Ensure slug is unique by checking against existing slugs
 * Appends -2, -3, etc. if needed
 */
export function ensureUniqueSlug(
  slug: string,
  existingSlugs: string[],
): string {
  if (!existingSlugs.includes(slug)) {
    return slug
  }

  let counter = 2
  let uniqueSlug = `${slug}-${counter}`

  while (existingSlugs.includes(uniqueSlug)) {
    counter++
    uniqueSlug = `${slug}-${counter}`
  }

  return uniqueSlug
}

/**
 * Generate a unique slug from a store name
 */
export function generateStoreSlug(
  storeName: string,
  existingSlugs: string[],
): string {
  const baseSlug = slugify(storeName)
  return ensureUniqueSlug(baseSlug, existingSlugs)
}
